export const environment = {
  production: true,
  apiUrl:"https://alawaelshipping.com/ATAdmin/"
};
